"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _sagaInjectors = _interopRequireDefault(require("./sagaInjectors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Dynamically injects a saga, passes component's props as saga arguments
 *
 * @param {string} key A key of the saga
 * @param {function} saga A root saga that will be injected
 * @param {string} [mode] By default (constants.RESTART_ON_REMOUNT) the saga will be started on component mount and
 * cancelled with `task.cancel()` on component un-mount for improved performance. Another two options:
 *   - constants.DAEMON—starts the saga on component mount and never cancels it or starts again,
 *   - constants.ONCE_TILL_UNMOUNT—behaves like 'RESTART_ON_REMOUNT' but never runs it again.
 *
 */
var _default = _ref => {
  let {
    key,
    saga,
    mode
  } = _ref;
  return WrappedComponent => {
    class InjectSaga extends _react.default.Component {
      constructor() {
        super(...arguments);
        _defineProperty(this, "injectors", (0, _sagaInjectors.default)(this.context.store));
      }
      componentWillMount() {
        const {
          injectSaga
        } = this.injectors;
        injectSaga(key, {
          saga,
          mode
        }, this.props);
      }
      componentWillUnmount() {
        const {
          ejectSaga
        } = this.injectors;
        ejectSaga(key);
      }
      render() {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, this.props);
      }
    }
    _defineProperty(InjectSaga, "WrappedComponent", WrappedComponent);
    _defineProperty(InjectSaga, "contextTypes", {
      store: _propTypes.default.object.isRequired
    });
    _defineProperty(InjectSaga, "displayName", "withSaga(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")"));
    return (0, _hoistNonReactStatics.default)(InjectSaga, WrappedComponent);
  };
};
exports.default = _default;